import React from "react";
import ContactForm from "../ContactFrom/ContactForm";
import icon1 from "../../images/icons/icon_map_mark_2.svg";
import icon2 from "../../images/icons/icon_calling_2.svg";
import icon3 from "../../images/icons/icon_mail_3.svg";
import icon4 from "../../images/icons/icon_calendar_2.svg";
import contactimage from '../../images/contact/contactsupport.png'

const ContactSection = (props) => {
  return (
    <section className="contact_section section_space bg-light">
      <div className="container">
        <div className="contact_info_box row d-flex">
          <div className="col-lg-3 col-md-6 col-sm-6 d-flex">
            <div className="iconbox_block text-center w-100 d-flex flex-column align-items-center">
              <div className="iconbox_icon">
                <img src={icon1} alt="Map Mark SVG Icon" />
              </div>
              <div className="iconbox_content flex-grow-1">
                <h3 className="iconbox_title">Location</h3>
                <p className="mb-0">
                  Karachi, Pakistan
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 d-flex">
            <div className="iconbox_block text-center w-100 d-flex flex-column align-items-center">
              <div className="iconbox_icon">
                <img src={icon2} alt="Calling SVG Icon" />
              </div>
              <div className="iconbox_content flex-grow-1">
                <h3 className="iconbox_title">Contact</h3>
                <p className="mb-0">+92 341 2686556</p>
                {/* <div className="mb-0">+88(0) 555-01117</div> */}
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 d-flex">
            <div className="iconbox_block text-center w-100 d-flex flex-column align-items-center">
              <div className="iconbox_icon">
                <img src={icon3} alt="User Check SVG Icon" />
              </div>
              <div className="iconbox_content flex-grow-1">
                <h3 className="iconbox_title">Email</h3>
                <p className="mb-0">zarnixtech@gmail.com</p>
                {/* <p className="mb-0">gmail.@example.com</p> */}
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 d-flex">
            <div className="iconbox_block text-center w-100 d-flex flex-column align-items-center">
              <div className="iconbox_icon">
                <img src={icon4} alt="Calendar SVG Icon" />
              </div>
              <div className="iconbox_content flex-grow-1">
                <h3 className="iconbox_title">Visit Between</h3>
                <p className="mb-0">Mon - Sat: 9.00-5.00</p>
                <p className="mb-0">Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="section_space pb-0">
          <div className="row justify-content-lg-between">
            <div className="col-lg-7">
              <div className="contact_form mb-0">
                <h3 className="details_item_info_title mb-1">
                  Send Us A Message
                </h3>
                <p className="mb-5">
                  Give us chance to serve and bring magic to your brand.
                </p>
                <ContactForm />
              </div>
            </div>
            <div className="col-lg-5 d-flex justify-content-center align-items-center">
              <img alt="contact-support" src={contactimage}></img>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
